import { useEffect } from "react";
import useExternalScript from "./hooks/useExternalScript";
import { usePartnerData } from "../../../providers/partnerData";
import ZenviaChat from "./components/ZenviaChat";
import Whatsapp from "./components/Whatsapp";

interface IProps {
  config: { type: string; extraConfig: string };
}

const RemoteSupport = ({ config }: IProps) => {
  if (config.type === "ZENVIA") {
    return <ZenviaChat></ZenviaChat>;
  }

  if (config.type === "WA") {
    return <Whatsapp whatsappNumber={config.extraConfig}></Whatsapp>;
  }

  return null;
};

export default RemoteSupport;
